import React, { CSSProperties } from 'react';
import { IOrganizationMember } from '@vivli/features/organizations/infrastructure/interface';
import { Color } from '@vivli/shared/theme';

const divStyle: CSSProperties = {
    lineHeight: 1,
    marginBottom: 5,
    marginTop: 5,
};
const nameStyle: CSSProperties = {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 4,
    color: Color.TEXT_DARK_BLUE,
};
const emailStyle: CSSProperties = {
    fontSize: 15,
    fontStyle: 'italic',
};

interface NameRowRendererViewProps {
    data: IOrganizationMember;
}

export const NameRowRendererView = ({ data }: NameRowRendererViewProps) => {
    return (
        <div style={divStyle}>
            <div style={nameStyle} title={data.displayName}>
                {data.displayName}
            </div>
            <div style={emailStyle} title={data.email}>
                {data.email}
            </div>
        </div>
    );
};
